import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between p-flex-column p-flex-sm-row" }
const _hoisted_2 = { class: "p-float-label p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "filled"
}, "Cerca...", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Nessun elemento trovato. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Caricamento in corso... ")
const _hoisted_7 = { class: "p-d-flex p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_EntityUserDialog = _resolveComponent("EntityUserDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      ref: "dt",
      value: _ctx.users,
      loading: _ctx.isLoading,
      rows: 10,
      "rows-per-page-options": [10, 20, 50, 100],
      paginator: true,
      "auto-layout": "",
      "striped-rows": "",
      responsiveLayout: "scroll",
      sortMode: "multiple",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
      filterDisplay: "row",
      globalFilterFields: ['name','surname','email'],
      stateStorage: "session"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-filter-slash",
            label: "Reset",
            class: "p-button-outlined",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearFilters()))
          }),
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
            class: "p-fluid p-ml-auto"
          }, [
            _createElementVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                id: "search",
                style: {"width":"100%"},
                modelValue: _ctx.filters.global.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters.global.value = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_4
            ])
          ], 32),
          _createVNode(_component_Button, {
            class: "p-ml-2",
            icon: "pi pi-plus",
            label: "Aggiungi",
            onClick: _ctx.onNewUser
          }, null, 8, ["onClick"])
        ])
      ]),
      empty: _withCtx(() => [
        _hoisted_5
      ]),
      loading: _withCtx(() => [
        _hoisted_6
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          ref: "name",
          field: "name",
          header: "Nome",
          sortable: true
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              class: "p-column-filter",
              onInput: ($event: any) => (filterCallback()),
              placeholder: "Cerca per nome"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
          ]),
          _: 1
        }, 512),
        _createVNode(_component_Column, {
          ref: "surname",
          field: "surname",
          header: "Cognome",
          sortable: true
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              class: "p-column-filter",
              onInput: ($event: any) => (filterCallback()),
              placeholder: "Cerca per cognome"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
          ]),
          _: 1
        }, 512),
        _createVNode(_component_Column, {
          ref: "email",
          field: "email",
          header: "E-mail"
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              class: "p-column-filter",
              onInput: ($event: any) => (filterCallback()),
              placeholder: "Cerca per email"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
          ]),
          _: 1
        }, 512),
        _createVNode(_component_Column, {
          field: "is_active",
          header: "Stato"
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_InputSwitch, {
              disabled: "",
              modelValue: data.is_active
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, null, {
          body: _withCtx(({data}) => [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-pencil",
                class: "p-mr-1 p-button-warning",
                onClick: ($event: any) => (_ctx.onEditUser(data))
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('edit'),
                  void 0,
                  { bottom: true }
                ]
              ]),
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-times",
                class: "p-button-danger",
                onClick: ($event: any) => (_ctx.onRemoveUser(data))
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('remove'),
                  void 0,
                  { bottom: true }
                ]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "loading", "filters"]),
    _createVNode(_component_EntityUserDialog, {
      visible: _ctx.showUserDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showUserDialog = $event)),
      entityId: _ctx.supplierId,
      "role-options": _ctx.roleOptions,
      user: _ctx.editUser,
      onSaved: _ctx.onSavedUser
    }, null, 8, ["visible", "entityId", "role-options", "user", "onSaved"])
  ], 64))
}